import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faEnvelope } from '@fortawesome/free-solid-svg-icons';
import { useBranding } from 'modules/App/hooks/useBranding';

// The upgrade surface for a WHITELABEL build.
//
// Plan pricing and the Stripe checkout are Carbon Glance commerce: the prices,
// the Stripe account and the Calendly demo call all belong to CG, so showing
// any of them on a partner's build quotes CG's rates to the partner's customer.
// Whitelabel tenants sell their own way, so every upgrade path routes to the
// brand's own support address instead — no prices, no call booking.
//
// Shared by /upgrade (App/pages/UpgradePage) and the free-supplier plans page
// so the two can't drift; the free-supplier UpgradeModal renders the same
// mailto inline as its footer CTA.
export default function WhitelabelUpgradeContact({
  title,
  description,
  className = 'rounded-2xl bg-white border border-slate-200 p-8 flex flex-col items-center text-center gap-3 max-w-md mx-auto',
}) {
  const brand = useBranding();
  const heading = title || `Premium features are available on ${brand.name}`;
  const body =
    description ||
    'Calculation, verification and compliance tooling can be added to your workspace. ' +
      `Contact ${brand.supportEmail} to get started.`;

  return (
    <div className={className}>
      <div className="w-12 h-12 rounded-full bg-primaryColor/10 flex items-center justify-center">
        <FontAwesomeIcon
          icon={faEnvelope}
          className="text-primaryColor text-lg"
        />
      </div>
      <h2 className="text-lg font-semibold text-slate-800 m-0">{heading}</h2>
      <p className="text-sm text-slate-500 m-0">{body}</p>
      <a
        href={`mailto:${brand.supportEmail}`}
        className="inline-flex items-center gap-1.5 text-sm font-medium rounded-xl bg-primaryColor text-white hover:bg-primaryColor/90 px-4 py-2 transition-colors no-underline mt-2"
      >
        <FontAwesomeIcon
          icon={faEnvelope}
          className="w-3.5 h-3.5 shrink-0"
        />
        Contact {brand.supportEmail}
      </a>
    </div>
  );
}
